export const rightData = [ "pawelsiwek.co.uk","p.f.siwek@gmail.com"]